import { render } from "./LimboNavigation.vue?vue&type=template&id=0da3bbe2&scoped=true"
import script from "./LimboNavigation.vue?vue&type=script&lang=js"
export * from "./LimboNavigation.vue?vue&type=script&lang=js"

import "./LimboNavigation.vue?vue&type=style&index=0&id=0da3bbe2&lang=scss&scoped=true"

import exportComponent from "/Users/maksimzugan/code/nacd-3-family/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da3bbe2"]])

export default __exports__